import { c as _c } from "react/compiler-runtime";
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { RefObject } from 'react';
interface Props {
  wrapperRef: RefObject<HTMLDivElement | null>;
  isFiltersOpen: boolean;
  isMobile: boolean;
  filtersWrapperSelector: string;
}
export const useFiltersPanelAnimation = t0 => {
  const $ = _c(11);
  const {
    wrapperRef,
    isFiltersOpen,
    isMobile,
    filtersWrapperSelector
  } = t0;
  let t1;
  if ($[0] !== filtersWrapperSelector || $[1] !== isFiltersOpen || $[2] !== isMobile || $[3] !== wrapperRef) {
    t1 = () => {
      if (isFiltersOpen && !isMobile && wrapperRef.current) {
        const filtersWrapper = wrapperRef.current.querySelector(filtersWrapperSelector);
        if (filtersWrapper) {
          gsap.fromTo(filtersWrapper, {
            height: 0,
            opacity: 0
          }, {
            height: "auto",
            opacity: 1,
            duration: 0.5,
            ease: "power2.out"
          });
        }
      }
    };
    $[0] = filtersWrapperSelector;
    $[1] = isFiltersOpen;
    $[2] = isMobile;
    $[3] = wrapperRef;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== isFiltersOpen || $[6] !== isMobile) {
    t2 = [isFiltersOpen, isMobile];
    $[5] = isFiltersOpen;
    $[6] = isMobile;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2 || $[9] !== wrapperRef) {
    t3 = {
      dependencies: t2,
      scope: wrapperRef
    };
    $[8] = t2;
    $[9] = wrapperRef;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  useGSAP(t1, t3);
};